import http from '../httpService';

export function getAllRevisionScope() {
  return http.get(`/revision-scopes?size=1000`);
}
export function updateRevisionScope(payload) {
  return http.put('/revision-scopes', payload);
}

export function createRevisionScope(payload) {
  return http.post('/revision-scopes', payload);
}

export function deleteRevisionScope(id) {
  return http.delete(`/revision-scopes/${id}`);
}

export function getAllRevisionScopesWithMultipleRevisionTypes(revisionTypes) {

  let string=''
  if (revisionTypes){
    for (let i = 0; i < revisionTypes.length; i++) {
      if(i<revisionTypes.length-1){
        string+="revisionTypeId.in" + "=" +revisionTypes[i].value +"&"
      }else{
        string+="revisionTypeId.in" + "=" +revisionTypes[i].value
      }
    }
  }




  return http.get(`/revision-scopes?${string}&size=10000`);
}